import * as React from 'react';
import { CSSProperties } from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium';
import ImageModal from '../Components/ImageModal';
import { browserHistory } from 'react-router'



// Existing Styles
const readyDiv: React.CSSProperties = {
    marginBottom: '40px',
    '@media (max-width: 768px)': {
        marginBottom: '20px', // Less bottom margin for mobile
      },
};


const headerStyle: React.CSSProperties = {
    fontSize: '34px',
    fontWeight: 900,
    textTransform: 'math-auto',
    textAlign: 'center',
    textDecoration: 'underline',
    marginBottom: '40px',
    fontFamily: '"RocknRoll One", sans-serif', // Specify the font family here
    '@media (max-width: 768px)': {
        fontSize: '24px', // Smaller header font size for mobile
        marginBottom: '20px', // Less bottom margin for mobile
      },
    
};

const subTextStyle: React.CSSProperties = {
    textAlign: 'center',
    marginBottom: '60px',
    fontSize: '19px',
    textTransform: 'math-auto',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    '@media (max-width: 768px)': {
        fontSize: '15px', // Smaller text for mobile
        marginBottom: '30px', // Less bottom margin for mobile
      },
};

const organizationStyle: React.CSSProperties = {
    textAlign: 'center',
    textTransform: 'math-auto',
    fontWeight: 900,
    fontSize: '20px',
    marginTop: '20px',
    fontFamily: '"RocknRoll One", sans-serif', // And here as well
    '@media (max-width: 768px)': {
        fontSize: '16px', // Smaller font size for mobile
        marginTop: '10px', // Less top margin for mobile
      },
};

const wrapperStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'rgb(244, 250, 255)',
    justifyContent: 'center',
    marginTop: '80px',
    '@media (max-width: 768px)': {
        marginTop: '20px',
        width: '100%',
    },
};

const contentStyle: CSSProperties = {
    width: '100%',
    maxWidth: '900px',
    '@media (max-width: 768px)': {
        maxWidth: '100%',
        marginTop: '40px',
    },
};

const clickToEnlargeStyle: CSSProperties = {
    textAlign: 'center',
    fontSize: '12px', // Small, but legible size
    color: '#666', // Subtle color, but feel free to adjust
    marginTop: '10px',
    marginBottom: '10px',
    '@media (max-width: 768px)': {
        display: 'none',
    },
};

const imagesRowStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  flexWrap: 'wrap',
  marginBottom: '10px', // Add space between rows
};

const imagesContainerStyle: CSSProperties = {
    display: 'flex',
    backgroundColor: 'white',
    justifyContent: 'space-around',
    alignItems: 'center',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
    flexWrap: 'wrap',
    marginBottom: '20px',
    '@media (max-width: 768px)': {
        flexDirection: 'column',
    },
};

const imageStyle: CSSProperties = {
  maxWidth: '45%',
  height: 'auto',
  boxSizing: 'border-box',
  padding: '5px',
  '@media (max-width: 768px)': { // Media query for mobile devices
    maxWidth: '100%', // Set maxWidth to 100% for mobile
  },
};

const imageContainerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
  },
};

// Modal Styles
const modalStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const modalContentStyle: CSSProperties = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '4px',
    maxWidth: '95%',
    maxHeight: '95%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };
  

const closeButtonStyle: CSSProperties = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
    background: '#333',
    color: '#fff',
    border: 'none',
    padding: '5px 10px',
    borderRadius: '5px',
};

const countdownStyle: CSSProperties = {
  fontWeight: 700, // Bold font for emphasis
  fontSize: '28px', // Increased font size for visibility
  color: '#FFFFFF', // Changed to white for contrast
  textShadow: '0px 1px 3px rgba(0, 0, 0, 0.6)', // Enhanced shadow for depth
  fontFamily: '"Source Code Pro", monospace', // Monospaced font for a modern, techy look
  margin: '10px 0', // Vertical spacing
  padding: '15px 20px', // Increased padding for better readability
  borderRadius: '10px', // More pronounced rounded corners
  backgroundColor: '#007bff', // Bright background color for attention
  display: 'inline-block', // Align better with surrounding text
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)', // Box shadow for depth
  border: '2px solid #0056b3', // Solid border for definition
  animation: 'pulseAnimation 2s infinite', // Animation to draw attention
  '@media (max-width: 768px)': {
    fontSize: '20px', // Adjust font size for smaller screens
    padding: '10px 15px', // Adjust padding for smaller screens
  },
  '@keyframes pulseAnimation': {
    '0%': { backgroundColor: '#007bff' },
    '50%': { backgroundColor: '#0056b3' },
    '100%': { backgroundColor: '#007bff' },
  },
};

const logoImageStyle: CSSProperties = {
  maxWidth: '350px',
  width: 'auto',
  height: 'auto',
  margin: '30px auto',
  display: 'block',
  '@media (max-width: 768px)': {
    maxWidth: '250px',
    margin: '20px auto',
  },
};

const chicagoAlumniContainerStyle: CSSProperties = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '30px 40px',
  margin: '30px auto',
  maxWidth: '800px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  border: '2px solid #FF8200',
  '@media (max-width: 768px)': {
    padding: '20px 25px',
    margin: '20px auto',
    maxWidth: '95%',
  },
};

const customDescriptionStyle: CSSProperties = {
  textAlign: 'center',
  marginBottom: '40px',
  fontSize: '18px',
  lineHeight: '1.8',
  fontFamily: '"RocknRoll One", sans-serif',
  color: '#1c1c1c',
  '@media (max-width: 768px)': {
    fontSize: '15px',
    marginBottom: '30px',
    lineHeight: '1.6',
  },
};

const openingLineStyle: CSSProperties = {
  fontSize: '26px',
  fontWeight: 'bold',
  color: '#FF8200',
  marginBottom: '25px',
  lineHeight: '1.4',
  fontFamily: '"RocknRoll One", sans-serif',
  textTransform: 'none',
  '@media (max-width: 768px)': {
    fontSize: '22px',
    marginBottom: '20px',
  },
};

const paragraphStyle: CSSProperties = {
  fontSize: '18px',
  lineHeight: '1.8',
  marginBottom: '20px',
  color: '#333333',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '16px',
    marginBottom: '16px',
    lineHeight: '1.6',
  },
};

const highlightStyle: CSSProperties = {
  color: '#FF8200',
  fontWeight: 'bold',
};

const callToActionStyle: CSSProperties = {
  fontSize: '20px',
  fontWeight: 'bold',
  color: '#1c1c1c',
  marginTop: '25px',
  marginBottom: '15px',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '17px',
    marginTop: '20px',
  },
};

const goVolsStyle: CSSProperties = {
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#FF8200',
  marginTop: '20px',
  fontFamily: '"RocknRoll One", sans-serif',
  textTransform: 'none',
  '@media (max-width: 768px)': {
    fontSize: '20px',
    marginTop: '15px',
  },
};

const clemsonContainerStyle: CSSProperties = {
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  padding: '32px 36px',
  margin: '30px auto 40px',
  maxWidth: '820px',
  boxShadow: '0 6px 20px rgba(82, 45, 128, 0.12)',
  border: '2px solid #F56600',
  '@media (max-width: 768px)': {
    padding: '24px 18px',
    margin: '20px auto 30px',
    maxWidth: '95%',
  },
};

const clemsonIntroStyle: CSSProperties = {
  fontSize: '20px',
  fontWeight: 'bold',
  color: '#522D80',
  marginBottom: '28px',
  lineHeight: '1.55',
  textAlign: 'center',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '17px',
    marginBottom: '22px',
  },
};

const clemsonPickupGridStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '20px',
  marginBottom: '24px',
  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr',
    gap: '16px',
    marginBottom: '20px',
  },
};

const clemsonInfoBlockStyle: CSSProperties = {
  backgroundColor: '#faf7ff',
  borderRadius: '12px',
  padding: '22px 24px',
  border: '1px solid rgba(82, 45, 128, 0.12)',
  textAlign: 'left',
  height: '100%',
  boxSizing: 'border-box',
  '@media (max-width: 768px)': {
    padding: '18px 16px',
  },
};

const clemsonInfoLabelStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 'bold',
  color: '#F56600',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  marginBottom: '14px',
  fontFamily: '"RocknRoll One", sans-serif',
};

const clemsonLocationNameStyle: CSSProperties = {
  fontSize: '21px',
  fontWeight: 'bold',
  color: '#522D80',
  lineHeight: '1.35',
  marginBottom: '10px',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '18px',
  },
};

const clemsonLocationDetailStyle: CSSProperties = {
  fontSize: '16px',
  lineHeight: '1.65',
  color: '#444444',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '15px',
  },
};

const clemsonDatesStyle: CSSProperties = {
  fontSize: '22px',
  fontWeight: 'bold',
  color: '#522D80',
  lineHeight: '1.35',
  marginBottom: '8px',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '19px',
  },
};

const clemsonTimesStyle: CSSProperties = {
  fontSize: '17px',
  lineHeight: '1.5',
  color: '#444444',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '15px',
  },
};

const clemsonReceiptStyle: CSSProperties = {
  backgroundColor: '#fff8f2',
  borderRadius: '12px',
  padding: '18px 22px',
  border: '1px solid rgba(245, 102, 0, 0.25)',
  textAlign: 'center',
  '@media (max-width: 768px)': {
    padding: '16px 14px',
  },
};

const clemsonReceiptLabelStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 'bold',
  color: '#F56600',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  marginBottom: '8px',
  fontFamily: '"RocknRoll One", sans-serif',
};

const clemsonReceiptTextStyle: CSSProperties = {
  fontSize: '17px',
  fontWeight: 'bold',
  lineHeight: '1.55',
  color: '#1c1c1c',
  fontFamily: '"RocknRoll One", sans-serif',
  '@media (max-width: 768px)': {
    fontSize: '15px',
  },
};


const viewRosterStyle: React.CSSProperties = {
  cursor: 'pointer',
  backgroundColor: '#007bff', // Use your theme's primary color here
  color: 'white',
  fontSize: '18px', // Larger font size for visibility
  fontWeight: 'bold', // Make the text bold
  padding: '10px 30px', // Adequate padding for a button
  border: 'none',
  borderRadius: '25px', // Rounded corners
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // A subtle shadow for depth
  transition: 'background-color 0.3s', // Smooth transition for hover effect
  textDecoration: 'none', // No underline
  ':hover': { // Radium's hover state
    backgroundColor: '#0056b3', // A slightly darker shade on hover
  },
  '@media (max-width: 768px)': {
    padding: '8px 20px', // Slightly smaller padding on mobile
    fontSize: '16px', // Slightly smaller font size on mobile
  },
};


const rosterButtonContainerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center', // Center horizontally
  alignItems: 'center', // Center vertically
  marginBottom: '40px', //
  flexDirection: 'column', // Stack vertically
  height: '100%', // Full height of the parent
};

  
// TBankerProofCard Component Types
type Props = {
  tbanker: Tgcc.TbankerInfo;
  proofId: string;
};

export class TBankerProofCard extends React.Component<Props, any>{
    private interval: NodeJS.Timeout | undefined;

  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false,
      currentImageSrc: '',
      proofImages: [], // Initializing the proofImages as an empty array
      rosterViewRequested: false,
      closingDate: null,
      countdown: '',
    };
  }

  componentDidMount() {
    this.loadProofImages();
    this.fetchClosingDateFromAPI(); // Rename to better reflect the action
    this.interval = setInterval(this.updateCountdown, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  async componentDidUpdate(prevProps: Props) {
    if (this.props.proofId !== prevProps.proofId) {
      await this.loadProofImages();
    }
  }

  fetchClosingDateFromAPI = () => {
    Request.fetchClosingDate(
      this.props.proofId,
      'tbanker/getStoreClosingDate',
      (closingDate) => {
        if (closingDate) {
          this.setState({ closingDate: new Date(closingDate) });
        } else {
          this.setState({ closingDate: null });
        }
      },
      (error) => {
        console.error('Failed to fetch closing date:', error);
        this.setState({ closingDate: null });
      }
    );
  };
  
  updateCountdown = () => {
    const { closingDate } = this.state;
    if (!closingDate) {
      return;
    }
  
    const now = new Date();
    const timeLeft = closingDate.getTime() - now.getTime();
  
    if (timeLeft > 0) {
      let countdownArray = [];
      
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      if (days > 0) countdownArray.push(`${days} days`);
  
      const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
      if (days > 0 || hours > 0) countdownArray.push(`${hours} hours`);
  
      const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
      if (days > 0 || hours > 0 || minutes > 0) countdownArray.push(`${minutes} minutes`);
  
      const seconds = Math.floor((timeLeft / 1000) % 60);
      countdownArray.push(`${seconds} seconds`);
  
      // Join the countdownArray elements into a single string, separated by spaces
      const countdown = countdownArray.join(' ');
      this.setState({ countdown });
    } else if (this.interval) {
      clearInterval(this.interval);
      this.setState({ countdown: "The store has closed." });
    }
  };
  

  
  loadProofImages = () => {
    Request.fetchImageUrlsFromBlob(this.props.proofId, this.loaded, this.error);
  };
  
  loaded = (imageFilenames: string[]) => {
    var proofId = this.props.proofId;
    const trimmedProofId = proofId.startsWith('WO') ? proofId.slice(2) : proofId;

    // Ensure there's no trailing slash in the base URL
    const baseUrl = `https://grafcowassets.blob.core.windows.net/tgcc-proof-assets/${trimmedProofId}`;

    // Combine the base URL with each filename, ensuring there's exactly one slash between them
    const fullImageUrls = imageFilenames.map(filename => {
        // If filename begins with a slash, remove it
        const sanitizedFilename = filename.replace(`${trimmedProofId}/`, '');
        return `${baseUrl}/${sanitizedFilename}`;  // This will always have exactly one slash
    });

    // Custom sort function
    const sortedImageUrls = this.sortImages(fullImageUrls);

    this.setState(prevState => ({
        ...prevState,
        proofImages: sortedImageUrls
    }));
};

  
  // Custom sort function to sort images
  sortImages = (images: string[]) => {
    // Define the order in which to sort the keywords
    const order = ['front', 'back', 'description'];
  
    // Sort images based on the order of keywords
    return images.sort((a, b) => {
      const aIndex = order.findIndex(keyword => a.includes(keyword));
      const bIndex = order.findIndex(keyword => b.includes(keyword));
      
      // If both images have defined keywords, sort by the order index
      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
  
      // If one of the images has a keyword, that image goes first
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
  
      // If neither image has a keyword, sort by filename to ensure consistency
      return a.localeCompare(b);
    });
  };
  
  error = (err: any) => {
    console.error('Error loading images:', err);
    this.setState(prevState => ({
      ...prevState,
      proofImages: [] // Set an empty array if there is an error
    }));
  };
  
  

  handleImageClick = (imgSrc: string) => {
    if (window.innerWidth > 768) {
      this.setState(prevState => ({
        ...prevState,
        isModalOpen: true,
        currentImageSrc: imgSrc
      }));
    }
  };

  handleCloseModal = () => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: false
    }));
  };
  renderImages = () => {
    // Determine the order of the images
    const frontImage = this.state.proofImages.find(image => image.includes('front'));
    const backImage = this.state.proofImages.find(image => image.includes('back'));
    const descriptionImage = this.state.proofImages.find(image => image.includes('description'));
    const otherImages = this.state.proofImages.filter(image => 
      !image.includes('front') && 
      !image.includes('back') && 
      !image.includes('description')
    );

    const uniqueOtherImages = otherImages.filter((value, index, self) => self.indexOf(value) === index);


    const pairedOtherImages = [];
    for (let i = 0; i < uniqueOtherImages.length; i += 2) {
      pairedOtherImages.push(uniqueOtherImages.slice(i, i + 2));
    }
  
  // Place the "Click to Enlarge" text in a separate container
  const clickToEnlargeText = (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <p style={clickToEnlargeStyle}>Click images to enlarge</p>
    </div>
  );

  // Render each pair of 'other' images on their own row
  const pairedOtherImagesRows = pairedOtherImages.map((pair, index) => (
    <div key={`paired-other-${index}`} style={imagesRowStyle}>
      {pair.map((src, idx) => (
        <img
          key={`img-${index}-${idx}`}
          style={imageStyle}
          src={src}
          alt={`Other Image ${index}-${idx}`}
          onClick={() => this.handleImageClick(src)}
        />
      ))}
    </div>
  ));

  // Render the front and back images on the same row
  const frontBackRow = (
    <div style={imagesRowStyle}>
      {frontImage && (
        <img
          style={imageStyle}
          src={frontImage}
          alt="Front"
          onClick={() => this.handleImageClick(frontImage)}
        />
      )}
      {backImage && (
        <img
          style={imageStyle}
          src={backImage}
          alt="Back"
          onClick={() => this.handleImageClick(backImage)}
        />
      )}
    </div>
  );
  
  // Render the description image on its own row
  const descriptionRow = descriptionImage ? (
    <div style={imagesRowStyle}>
      <img style={imageStyle} src={descriptionImage} alt="description" />
    </div>
  ) : null;

  return (
    <div style={imagesContainerStyle}>
      {clickToEnlargeText}
      {frontBackRow}
      {pairedOtherImagesRows}
      {descriptionRow}
    </div>
  );
};
  
renderHeader = () => {
  const { closingDate } = this.state;
  const { countdown } = this.state;

  
  if (this.props.tbanker && this.props.tbanker.status !== 'CLOSED') {
    // Special handling for WO789437 - Clemson Central Spirit Tent pickup TBanker
    if (this.props.proofId === 'WO789437') {
      return (
        <div>
          <h2 style={headerStyle}>Order Your Merch</h2>
          {
            closingDate && countdown ? (
              <p style={subTextStyle}>
                <span style={countdownStyle}>
                  <div> Store closes in: </div>
                   {countdown}
                </span>
              </p>
            ) : null
          }
          <div style={clemsonContainerStyle}>
            <div style={clemsonIntroStyle}>
              Explore the designs below! You can choose your preferred size and quantities.
            </div>
            <div style={clemsonPickupGridStyle}>
              <div style={clemsonInfoBlockStyle}>
                <div style={clemsonInfoLabelStyle}>Pick-Up Location</div>
                <div style={clemsonLocationNameStyle}>Central Spirit Tent</div>
                <div style={clemsonLocationDetailStyle}>
                  Clemson's Campus<br />
                  In front of Rhodes Hall<br />
                  Beside the Library Bridge
                </div>
              </div>
              <div style={clemsonInfoBlockStyle}>
                <div style={clemsonInfoLabelStyle}>Pick-Up Dates &amp; Times</div>
                <div style={clemsonDatesStyle}>September 8 – 11</div>
                <div style={clemsonTimesStyle}>10:00 AM – 3:30 PM daily</div>
              </div>
            </div>
            <div style={clemsonReceiptStyle}>
              <div style={clemsonReceiptLabelStyle}>At Pick-Up</div>
              <div style={clemsonReceiptTextStyle}>
                Show your receipt and tell us what sizes you ordered.
              </div>
            </div>
          </div>
        </div>
      );
    }

    // Special handling for WO774992 - Chicago Alumni custom TBanker
    if (this.props.proofId === 'WO774992') {
      return (
        <div>
          <h2 style={headerStyle}>Order Your Merch</h2>
          {
            closingDate && countdown ? (
              <p style={subTextStyle}>
                <span style={countdownStyle}>
                  <div> Store closes in: </div>
                   {countdown}
                </span>
              </p>
            ) : null
          }
          <img 
            src={Tgcc.ResolveUrl('~/images/Chicago Alumni - Shortcut-R-1Line (CMYK) (1).jpg')} 
            alt="Chicago Alumni Chapter Logo" 
            style={logoImageStyle}
          />
          <div style={chicagoAlumniContainerStyle}>
            <div style={openingLineStyle}>
              It's here! Our limited-edition <span style={highlightStyle}>UT Chicago Alumni</span> T-shirt has arrived.
            </div>
            <div style={paragraphStyle}>
              Designed by a UT alum right here in Chicago and printed on a premium <span style={highlightStyle}>Comfort Colors</span> short-sleeve tee, this shirt is the perfect way to rep the Vols all year long.
            </div>
            <div style={paragraphStyle}>
              Pick up your group-shipped order at all official UT basketball watch parties at <span style={highlightStyle}>Clover Lincoln Park</span> in the new year.
            </div>
            <div style={paragraphStyle}>
              A portion of proceeds supports our <span style={highlightStyle}>Chicago-area student scholarship fund</span>.
            </div>
            <div style={callToActionStyle}>
              Please scroll down to order.
            </div>
            <div style={goVolsStyle}>
              Thank you for helping us give back & <span style={{ color: '#1c1c1c' }}>Go Vols</span>! 🧡
            </div>
          </div>
        </div>
      );
    }
    
    return (
      <div>
        <h2 style={headerStyle}>Order Your Merch</h2>
        {
          closingDate && countdown ? (
            <p style={subTextStyle}>
              <span style={countdownStyle}>
                <div> Store closes in: </div>
                 {countdown}
              </span>
            </p>
          ) : null
        }
        <p style={subTextStyle}>
          <div style={readyDiv}>Eager to get started?</div>
          Explore the designs below. You can choose your preferred sizes and quantities, whether it's for a bulk organization order or a personal shipment to your address.
        </p>
      </div>
    );
  } else {
    return (
      <div>
        <h2 style={headerStyle}>The T-Banker is Now Closed</h2>
        <div style={rosterButtonContainerStyle}>
          <div style={viewRosterStyle} onClick={this.viewRoster}>View Roster</div>
        </div>        
      </div>
    );
  }
};

viewRoster = () => {
  console.log("View Roster");
  const rosterUrl = Tgcc.Routes.ProofRoster(this.props.proofId);

  if (this.isUserLoggedIn()) {
      console.log('User is logged in, navigating to roster');
      browserHistory.push(rosterUrl);
  } else {
      console.log('User is NOT logged in, setting rosterViewRequested to true');
      this.setState(prevState => ({
          ...prevState, // spread the previous state
          rosterViewRequested: true // update the rosterViewRequested property
      }));
      const returnUrl = encodeURIComponent(rosterUrl);
      browserHistory.push(`/login?returnUrl=${returnUrl}`);
  }
};


isUserLoggedIn = (): boolean => {
  const loginDataJson = localStorage.getItem("LoginData");
  if (loginDataJson) {
    const loginData: Tgcc.LoginData = JSON.parse(loginDataJson);
    // Check if the token is present and not expired
    const isTokenValid = loginData.token && new Date(loginData.expires) > new Date();
    return isTokenValid;
  }
  return false;
};


  render() {
    // Check if there are proof images from the blob
    if (this.state.proofImages.length > 0) {
      return (
        <StyleRoot>
          <div style={wrapperStyle} className="proofWrapper">
            <div style={contentStyle} id="contentStyleProof">
              {this.renderHeader()}
              {this.renderImages()}
            </div>
          </div>
  
          <ImageModal
            isOpen={this.state.isModalOpen}
            imgSrc={this.state.currentImageSrc}
            onClose={this.handleCloseModal}
          />
        </StyleRoot>
      );
    } else {
      // Fallback to original proof for a single image
      const imgPath = Tgcc.getProofPath(this.props.proofId);
      return (
        <div style={wrapperStyle} className='proofWrapper'>
          <div style={contentStyle}>
              {this.renderHeader()}
              <div style={imageContainerStyle}>
            <img style={imageStyle} src={imgPath} className="pfImg" alt="Proof"/>
            </div>
          </div>
        </div>
      );
    }
  }
}